import { render, staticRenderFns } from "./AsiCardDetailEntryTranslatedValue.vue?vue&type=template&id=1d8fc609&scoped=true"
import script from "./AsiCardDetailEntryTranslatedValue.vue?vue&type=script&lang=ts"
export * from "./AsiCardDetailEntryTranslatedValue.vue?vue&type=script&lang=ts"
import style0 from "./AsiCardDetailEntryTranslatedValue.vue?vue&type=style&index=0&id=1d8fc609&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8fc609",
  null
  
)

export default component.exports